import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { I18nProvider } from './i18n/useTranslation';
import { Provider } from 'react-redux';
import store from './store/index';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <I18nProvider initialLanguage="en">
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </I18nProvider>
      
    </Provider>
  </React.StrictMode>
);